export default function CheckOption({ checked, onChange, label }) {
  return (
    <label
      className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
        checked
          ? 'border-brand-gold bg-brand-gold/5'
          : 'border-neutral-800 bg-neutral-900/50 hover:border-neutral-700'
      }`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="accent-brand-gold"
      />
      <span className="text-white text-sm">{label}</span>
    </label>
  );
}
